/* eslint-disable jsx-a11y/alt-text */
import { FC, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { Api } from '../../api'
import { Button } from '../../components/Button'
import { Link } from '../../components/Link'
import { Modal } from '../../components/Modal'
import { isPlan, mapPacks, mapPlans, Packages } from '../../components/Packages'
import packagesS from '../../components/Packages/Packages.module.css'
import { useGet } from '../../hooks/get'
import { useSign } from '../../hooks/sign'
import { useSwitch } from '../../hooks/switch'
import { useUser } from '../../hooks/user'
import s from './Purchase.module.css'

const Purchase: FC = () => {
  const params = useParams()

  const { user } = useUser()
  const sign = useSign()

  const { data: item } = useGet<Dto.Plan | Dto.Pack | Dto.Product>(
    user && `member_portal/${params.type}s/${params.id}`
  )

  const { on: pending, open: startPending, close: stopPending } = useSwitch()

  const [result, setResult] = useState<string>()

  const handleSubmit = async () => {
    if (!loaded) {
      return
    }

    try {
      startPending()
      await Api.post(
        'purchases',
        {
          gym_id: user.gymId,
          user_id: user.userId,
          payment_method: item.gym!.payment_method,
          pos_items:
            'in_stock' in item
              ? [
                  {
                    type: 'product',
                    type_id: item.id,
                    name: item.name,
                    quantity: 1,
                    price: item.price,
                  },
                ]
              : [],
          ...('plan_type' in item && {
            gym_plan_id: item.id,
            gym_plan_payment_schedule: item.payment_schedule || 'weekly',
            gym_plan_price: false,
          }),
          ...('pack_type' in item && {
            gym_packs: [{ id: item.id, price: false }],
          }),
        },
        { memberAuth: true }
      )
      setResult('Purchase succeeded. You can close this page safely.')
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message)
      }
    } finally {
      stopPending()
    }
  }

  const loaded = !!(user && item)

  useEffect(() => {
    if (!user) {
      sign.start()
    }
  }, [sign, user])

  return (
    <>
      <Helmet>
        <title>Purchase a {params.type}</title>
      </Helmet>
      {loaded && (
        <div className={s.root}>
          <img
            {...('image_url' in item && item.image_url
              ? {
                  src: item.image_url,
                  alt: item.name,
                }
              : {
                  src: item.gym!.gym_logo,
                  alt: item.gym!.name,
                })}
            className={s.logo}
          />
          {'in_stock' in item ? (
            <ul className={packagesS.root} data-large>
              <li className={packagesS.item} data-selected>
                <div className={packagesS.type}>Product</div>
                <div className={packagesS.info}>
                  <div className={packagesS.price}>
                    <div className={packagesS['price-number']}>
                      ${item.price}
                    </div>
                  </div>
                  <div>
                    <div className={packagesS.name}>{item.name} </div>
                  </div>
                  <div className={packagesS.description}>
                    {item.description}
                  </div>
                </div>
              </li>
            </ul>
          ) : (
            <Packages
              items={isPlan(item) ? mapPlans([item]) : mapPacks([item])}
              defaultSelected={item.id}
              large
            />
          )}
          <Button
            block
            pending={pending}
            onClick={handleSubmit}
            className={s.pay}
          >
            Pay
          </Button>
          <footer className={s.copyright}>
            Powered by
            <br />
            <Link href="https://xoda.com/" target="_blank">
              <img src="/images/logo.svg" alt="Xoda" />
            </Link>
          </footer>
        </div>
      )}
      {sign.element}
      <Modal opened={!!result}>{result}</Modal>
    </>
  )
}

export { Purchase }
